import GuaranteeSearch from "./GuaranteeSearch.js";
import style from "./GuaranteeSearch.module.css";
import searchlogo from "../../assets/images/searchlogo.png";
export default function Main() {
  return (
    <>
      <div className={`${style.indexSearchBox} gsearch`}>
        <div className={style.indexSearchBoxc}>
          <img src={searchlogo} className={style.searchlogo} id="search" />
          <div className={style.searchinput}>
            {" "}
            <GuaranteeSearch />
          </div>
        </div>
      </div>
    </>
  );
}
